import { render } from "./SetupForm.vue?vue&type=template&id=061ed91e"
import script from "./SetupForm.vue?vue&type=script&lang=js"
export * from "./SetupForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/magpie/dnd/client/gamemasterai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__